import { useState, useEffect } from 'react';

type NetworkStatus = 'offline' | 'online';

/**
 * Alerts us to whether the network is online or not
 */
export default function useNetworkStatus(): NetworkStatus {
  const [networkStatus, setNetworkStatus] = useState<NetworkStatus>('online');

  useEffect(() => {
    function handleOffline() {
      setNetworkStatus('offline');
    }

    function handleOnline() {
      setNetworkStatus('online');
    }

    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);

    return () => {
      removeEventListener('offline', handleOffline);
      removeEventListener('online', handleOnline);
    };
  }, []);

  return networkStatus;
}
